import React from 'react';
import circusTentRedStripes from '../../SVGs/icons/circus_tent_red_stripes.png';

export default function CircusTentRedStripes({
  className,
  style,
  onMouseEnter,
  onMouseLeave,
}) {
  return (
    <img
      src={circusTentRedStripes}
      alt=""
      className={className}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      aria-hidden="true"
    />
  );
}
